import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as locationActions } from '../../../actions/locationActions';
import { actions as locationTaskActions } from '../../../actions/locationTaskActions';
import Drawer from '../../Common/Drawer/Drawer';
import InputText from '../../Common/InputText';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';
import Notification from '../../Common/Notification';
import Icon from '../../Common/Icon';
import { MAX_LOCATIONS_SELECTED } from '../../../constants/constants';
import './LocationSelectorDrawer.scss';

export class LocationSelectorDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            searchTerm: "",
            locations: [],
            resultLocations: [],
            isFormValid: true,
            isLoading: true,
            selectedLocationIds: this.props.taskListState.searchParams.locationKeys,
            isSearchingLocations: false,
            tempSelectedLocation: null,
            allLocationsSelected: false
        }
    }

    componentDidMount = async () => {
        await this.loadLocations();
    }

    loadLocations = async () => {
        try {
            const response = await this.props.locationActions.searchByName(null);
            if (response.type === types.SEARCH_LOCATION_NAME_SUCCESS) {
                this.setState({ 
                    allLocationsSelected: (response.payload.locations.length === this.state.selectedLocationIds.length) ? true : false,
                    locations: response.payload.locations,
                    resultLocations: response.payload.locations //initializing results with all locations
                });
            } else if (response.type === types.SEARCH_LOCATION_NAME_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.props.onCancel();
            }
            this.setState({ isLoading: false });
        } catch (error) {
            Notification("error", "Error", error);
            this.props.onCancel();
        }
    }

    searchLocations = () => {
        this.setState({ isSearchingLocations: true });

        const { locations, searchTerm } = this.state;

        if (locations) {
            if (searchTerm) {
                const lowerSearchTerm = searchTerm.toLowerCase();
                //search by name and abbrev
                const resultLocations = locations.filter(l => l.name.toLowerCase().indexOf(lowerSearchTerm) > -1 || l.abbreviation.toLowerCase().indexOf(lowerSearchTerm) > -1);

                this.setState({
                    ...this.state,
                    resultLocations
                });
            } else {
                //return all locations if search term is falsey
                this.setState({
                    ...this.state,
                    resultLocations: locations
                });
            }
        }
        this.setState({ isSearchingLocations: false });
    }

    updateTerm = (e) => {
        const term = e.target.value;
        this.setState({ searchTerm: term }, () => this.searchLocations());
    }

    selectLocation = (location) => {

        if (this.state.selectedLocationIds.indexOf(location.id) == -1) {
            let locationIds = [];

            if (this.props.isSingleSelect === true) {
                locationIds = [location.id]; //only allow 1 location be selected
            } else {
                locationIds = this.state.selectedLocationIds.slice();
                locationIds.push(location.id);
            }

            this.setState({ selectedLocationIds: locationIds, tempSelectedLocation: location, isFormValid: true });
        }

    }

    removeLocation = (locationId) => {
        const index = this.state.selectedLocationIds.indexOf(locationId)
        const locationIds = this.state.selectedLocationIds.slice();
        locationIds.splice(index, 1);
        this.setState({ selectedLocationIds: locationIds, searchTerm: "" });
    }

    renderSelectedLocations = (id) => {
        const location = this.state.locations.find(m => m.id === id);
        return location.name;
    }

    onUpdate = () => {
        this.setState({ isLoading: true });
        const { selectedLocationIds, locations } = this.state;

        if (selectedLocationIds && selectedLocationIds.length > 0) {
            const selectedLocations = locations.filter(l => selectedLocationIds.includes(l.id));
            this.props.locationTaskActions.setLocationKeys(selectedLocationIds)
            this.props.onComplete(selectedLocations);
            this.setState({ isLoading: false});
        } else {
            this.setState({ isFormValid: false, isLoading: false });
        }
    }

    onSelectAll = () => {
        this.setState({ tempSelectedLocation: null, selectedLocationIds: this.state.locations.map(m => m.id), allLocationsSelected: true });
    }

    onDeselectAll = () => {
        this.setState({ selectedLocationIds: [], allLocationsSelected: false });
    }

    getLocationClassName = (location) => {
        if(this.state.allLocationsSelected){
            return "list-group-item";
        } else {
            return (location === this.state.tempSelectedLocation) ? "list-group-item active" : "list-group-item selectable";
        }
    }

    render() {

        const resultText = (this.state.resultLocations && this.state.resultLocations.length == 1) ? "result" : "results";

        return (
            <div className={this.props.isOpen ? "" : "d-none"}>
                <Drawer isWide={false} title='Change Locations'
                    onSaveClick={this.onUpdate}
                    saveText='Update'
                    onCancelClick={this.props.onCancel}
                    isSaveDisabled={this.state.isLoading}>
                    <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                        <div className="location-selector-drawer">
                            <div className="row mb-3">
                                {!this.state.allLocationsSelected &&
                                    <div className="col-12 mb-1 selected-locations">Selected Locations:</div>                                
                                }
                                {this.state.isFormValid === false &&
                                    <div className="col-12 pl-3 pr-3">
                                        <div className="alert alert-danger">At least 1 selected location is required</div>
                                    </div>
                                }
                                {this.state.locations && this.state.locations.length > 0 && !this.state.allLocationsSelected && this.state.selectedLocationIds.map(m =>
                                    <div key={m} className="col-12">
                                        <span className="me-2 remove" onClick={() => this.removeLocation(m)} >
                                            <Icon name="times" />
                                        </span>{this.renderSelectedLocations(m)}
                                    </div>
                                )
                                }
                            </div>

                            <form onSubmit={(e) => e.preventDefault()} noValidate>
                                {this.props.isOpen && !this.state.allLocationsSelected &&
                                    <InputText
                                        isFocused={true}
                                        name="locationSearch"
                                        value={this.state.searchTerm}
                                        label="Search"
                                        type="text"
                                        onChange={this.updateTerm} />
                                }
                            </form>
                            <LoadingIndicator isLoading={this.state.isSearchingLocations}>
                                {this.state.resultLocations && this.state.resultLocations.length > 0 &&
                                    <Fragment>
                                        { this.state.locations.length <= MAX_LOCATIONS_SELECTED && this.state.allLocationsSelected && !this.props.isSingleSelect &&
                                            <Fragment>
                                                <div className="select-all" onClick={this.onDeselectAll}>Deselect All</div>
                                                <div className="location-results">{this.state.locations.length} locations selected</div>
                                            </Fragment>
                                            
                                        }
                                        { this.state.locations.length <= MAX_LOCATIONS_SELECTED && !this.state.allLocationsSelected && !this.props.isSingleSelect &&
                                            <Fragment>
                                                <div className="select-all" onClick={this.onSelectAll}>Select All</div>
                                                <div className="location-results">{this.state.resultLocations.length} {resultText} found</div>
                                            </Fragment>
                                        }

                                        <ul className="list-group">
                                            {this.state.resultLocations && this.state.resultLocations.length > 0 && this.state.resultLocations.map(location =>
                                                <li className={this.getLocationClassName(location)}
                                                    key={location.name + location.id} //React wasn't rendering the list correctly with only one identifier, two were added to remedy the problem
                                                    onClick={() => this.selectLocation(location)}>{location.name}
                                                </li>
                                            )
                                            }
                                        </ul>
                                    </Fragment>
                                }
                                {this.state.resultLocations && this.state.resultLocations.length === 0 &&
                                    <div className="location-results">No results</div>
                                }
                            </LoadingIndicator>
                        </div>
                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

LocationSelectorDrawer.propTypes = {
    taskListState: PropTypes.object.isRequired,
    locationActions: PropTypes.object.isRequired,
    locationTaskActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isSingleSelect: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
    return {
        taskListState: state.taskListState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        locationActions: bindActionCreators(locationActions, dispatch),
        locationTaskActions: bindActionCreators(locationTaskActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelectorDrawer);